// The CASA screens Ask Gargi knows: the name shown in the drawer, the key sent with questions (analytics-server's
// PAGES uses it to start from the right data) and questions worth asking there. Order matters: the first match wins.
export interface GargiPage {
  screen: string;
  name: string;
  questions: string[];
}

const PAGES: { pattern: RegExp; page: GargiPage }[] = [
  { pattern: /^\/growth-desk/, page: { screen: 'growth-desk', name: 'Growth Desk', questions: [
    'Which goal is furthest behind, and what would close the gap?',
    'Which journeys really added sales against the customers held back?',
    'What should the team do this week, and who should own it?',
  ] } },
  { pattern: /^\/intelligence/, page: { screen: 'gargi', name: 'Gargi', questions: [
    'Who should we target in the next two weeks, and with what?',
    'Which stores are behind this month, and what would close the gap?',
    'What will sales look like next month, and why?',
  ] } },
  { pattern: /product-analysis/, page: { screen: 'product-analysis', name: 'Product Analysis', questions: [
    'Which categories are slipping against last year, and why?',
    'Which styles stopped selling recently — stock or demand?',
    'What should we cross-sell to last month\'s buyers?',
  ] } },
  { pattern: /store-analysis/, page: { screen: 'store-analysis', name: 'Store Analysis', questions: [
    'Which stores fell most against last period, and what drove it?',
    'Which stores are losing repeat customers?',
    'Compare the top and bottom stores in the same city.',
  ] } },
  { pattern: /store-sales-prediction|store-prediction/, page: { screen: 'store-prediction', name: 'Store Sales Prediction', questions: [
    'Which stores will miss target this month, and by how much?',
    'Where is the forecast most at risk?',
  ] } },
  { pattern: /customer-analysis|broad-segment|customer-segment/, page: { screen: 'customer-analysis', name: 'Customer Analysis', questions: [
    'How many repeaters are at risk, and how do we win them back?',
    'Why is the dropped group so large, and what can we still save?',
    'Which customers are due to buy now by their own rhythm?',
  ] } },
  { pattern: /executive-summary/, page: { screen: 'executive-summary', name: 'Executive Summary', questions: [
    'Summarise this month for leadership: what moved and why.',
    'What are the three biggest opportunities right now?',
  ] } },
  { pattern: /festival/, page: { screen: 'festival-analysis', name: 'Festival Analysis', questions: [
    'How did the last festival compare with last year?',
    'Who should we bring back before the next festival?',
  ] } },
  { pattern: /campaign/, page: { screen: 'campaign-analysis', name: 'Campaign Analysis', questions: [
    'Which campaigns earned the most per message last month?',
    'Which channel should get more of our sends?',
  ] } },
  { pattern: /customer-360/, page: { screen: 'customer-360', name: 'Customer 360', questions: [
    'Which customers like this one should we contact this week?',
  ] } },
  { pattern: /abandon/, page: { screen: 'abandonment', name: 'Abandonment Intelligence', questions: [
    'How much is sitting in abandoned carts, and who can we still reach?',
    'Which products are browsed most but rarely bought?',
  ] } },
  { pattern: /^\/journeys/, page: { screen: 'journeys', name: 'Journey Builder', questions: [
    'Which of our journeys earn the most per message?',
    'Design a win-back journey for lapsed high-value customers.',
  ] } },
  { pattern: /^\/settings/, page: { screen: 'settings', name: 'Settings', questions: [
    'Explain our RFM segments and how many customers are in each.',
    'Are our at-risk and lapsed days right for how often customers buy?',
    'Which festivals are set up, and are their dates right for this year?',
  ] } },
  { pattern: /^\/(home|dashboard)?\/?$|overview/, page: { screen: 'overview', name: 'Overview', questions: [
    'How did this period compare with the previous one, and why?',
    'What should we do this week to grow sales?',
  ] } },
];

// The page for a path; any other screen is named from the browser title, with general questions.
export const gargiPage = (path: string, title: string): GargiPage => (
  PAGES.find((p) => p.pattern.test(path))?.page
  ?? { screen: path.replace(/^\//, '').split('/')[0] || 'home', name: title.replace(/\s*-\s*Casaretail.*$/i, '').trim() || 'This page', questions: [] }
);
